<template>
    <generic-element-tile-container
        :id="campaign.first_revision_id"
        :small="small"
        :colClass="elementClass"
        :cardClass="['campaign-card']"
        entityName="campaign-card"
    >
        <div class="element-data"
             :data-type="campaign.is_placeholder ? 'campaignplaceholder' : 'campaign'"
             :data-campaign-id="campaign.first_revision_id"
             :data-campaign-dynamic="campaign.dynamic"
             :data-preview-name="campaign.last_preview"
             :data-display-name="campaign.name"
             :data-resolution="campaign.parameters.resolution"
             :data-duration="campaign.parameters.duration"
             :data-valid-from="campaign.parameters['valid-from']"
             :data-valid-to="campaign.parameters['valid-to']"
        />

        <generic-element-tile
            :id="`campaign-info-${campaign.first_revision_id}`"
            :title="campaign.name"
            :img="campaign"
            :src="campaign.last_preview"
            :height="'150px'"
            :addMode="campaign.is_placeholder"
            :noIcon="campaign.is_placeholder"
            :showHashtag="campaign.dynamic"
            @click="showCampaign"
        />

        <v-card-actions :id="'campaign-actions-' + campaign.last_preview" v-if="actionsAvailable">
            <v-btn icon v-if="deletePrivilege === '1' || editPrivilege === '1'" @click="selectCampaign()" :color="selected ? 'primary' : ''">
                <v-icon>{{ selected ? 'fa-regular fa-square-check' : 'fa-regular fa-square' }}</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn icon v-if="editPrivilege === '1'" @click="editCampaign()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-pencil</v-icon>
            </v-btn>

            <v-btn icon v-if="deletePrivilege === '1'" @click="deleteCampaigns()" :color="selected ? 'primary' : ''">
                <v-icon>fa-regular fa-trash</v-icon>
            </v-btn>
        </v-card-actions>
        <v-tooltip-wrapper
            :activator="actionsAvailable ? '#campaign-actions-' + campaign.first_revision_id : '#campaign-info-' + campaign.first_revision_id"
            v-if="campaign.is_placeholder !== true">
            <div>
                <template v-if="campaign.dynamic">
                    <i class="fa-regular fa-hashtag"></i>&nbsp;
                </template>
                {{ campaign.name }}<br/>
                {{ t_validity }}: {{ campaign.parameters['validity-text']}}<br/>
                {{ t_added }}: {{ campaign.created_at }}<br/>
                {{ t_modified }}: {{ campaign.updated_at }}
            </div>
        </v-tooltip-wrapper>
    </generic-element-tile-container>
</template>

<script>
    import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'
    import GenericElementTile from "../common/genericElementTile.vue";
    import GenericElementTileContainer from "../common/genericElementTileContainer.vue";

    export default {
        components: {
            GenericElementTileContainer,
            GenericElementTile,
            VTooltipWrapper,
        },
        props: [
            'campaign',
            'small',
            'mode',
            'viewPrivilege',
            'editPrivilege',
            'deletePrivilege',
            'elementClass',
            'dragDrop'
        ],
        data: function () {
            return {
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                t_edit: Lang.langGet("Edit"),
                t_delete: Lang.langGet("Delete"),
                t_validity: Lang.langGet("Validity"),
                t_file_name: Lang.langGet("Filename"),
                activeProject: Laravel.activeProject,
                selected: false,
            }
        },
        computed: {
            actionsAvailable: function () {
                return this.deletePrivilege === '1' || this.editPrivilege === '1';
            },
            cols: function () {
                if (this.elementClass === 'two-in-a-row') {
                    return 6;
                } else if (this.elementClass === 'three-in-a-row') {
                    return 4;
                } else if (this.elementClass === 'four-in-a-row') {
                    return 3;
                } else if (this.elementClass === 'five-in-a-row') {
                    return 2;
                }
            },
        },
        methods: {
            editCampaign: function () {
                EaseEventBus.fire('editCampaign', this.campaign);
            },
            deleteCampaign: function () {
                EaseEventBus.fire('deleteCampaign', this.campaign);
            },
            showCampaign: function () {
                if (this.campaign.is_placeholder === true) {
                    EaseEventBus.fire('newContent', 'campaignplaceholder');
                } else {
                    const media = {...this.campaign, mime_type: 'image/jpg', display_name: this.campaign.name};
                    EaseEventBus.fire('showMedia', media);
                }
            },
            selectCampaign: function () {
                this.selected = !this.selected;
                EaseEventBus.fire('selectCampaign');
            }
        },
        mounted() {
            EaseEventBus.listen('updateCampaignlist', () => {
              this.selected = false;
            });
        }
    }
</script>
